import React, { useEffect, useMemo, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper, Select, MenuItem,
    useMediaQuery, Button, TextareaAutosize, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Checkbox
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import Titlebar from '../TitleBar';
import { PurchaseOrdMaster } from '../TitleList';
import styled, { inputImages, inputStyles } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentDate } from '../../Utils/Dateutils';
import { selectCloths, selectFirm, selectParty, selectPoNo } from '../Selectors/Master/ItemSelectors';
import { fetchClothData } from '../../Store/PHPSlice/Cloth';
import { createPOEntry, fetchPoNo } from '../../Store/PHPSlice/Purchase/PoNo';
import { fetchPartyData } from '../../Store/PHPSlice/Party';
import { fetchCompanyData } from '../../Store/PHPSlice/Firm';
import Dropdown from '../FieldsComponents/Dropdown';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';
import CircularProgress from '@mui/material/CircularProgress';
import RadioComponent from '../FieldsComponents/RadioComponent';
import axios from 'axios';



const PurchaseOrderEntry = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [formData, setFormData] = useState({
        cloth: '',
        vender: '',
        PoNo: '',
        ordt: getCurrentDate(),
        firm: '',
        tQtyM: '',
        amt: '',
        taxAmt: '',
        fAmt: '',
        shftTo: '',
        ref: '',
        soId: '',
        ordtype: 'Manual',
        userId: userdata?.ID
    });
    const [tableRows, setTableRows] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [openDropdowns, setOpenDropdowns] = useState({});
    const [solist, setSolist] = useState([]);

    const [loading, setLoading] = useState(false);

    const actionMap = {
        cloth: fetchClothData,
        vender: fetchPartyData
        // Add more mappings if needed
    };
    const dispatch = useDispatch();
    const clothList = useSelector(selectCloths);
    const getPoNo = useSelector(selectPoNo);
    const partyList = useSelector(selectParty);
    const firmList = useSelector(selectFirm);

    useEffect(() => {
        dispatch(fetchClothData());
        dispatch(fetchPoNo());
        dispatch(fetchPartyData());
        dispatch(fetchCompanyData());
        fetchSaleorderdata();
        Object.keys(openDropdowns).forEach((dropdown) => {
            if (openDropdowns[dropdown]) {
                const action = actionMap[dropdown];
                if (action) {
                    dispatch(action());
                }
            }
        });
    }, [openDropdowns, dispatch]);

    useEffect(() => {
        if (getPoNo?.data) {
            var po = getPoNo?.data?.poNo;
            setFormData((prevFormData) => ({
                ...prevFormData,
                PoNo: po
            }));
        }
    }, [getPoNo]);

    const fetchSaleorderdata = async () => {
        try {
            const res = await axios.get(`${baseUrl}?apicall=getSaleorderNoPurchaseOrderCloth`);
            const data = res?.data?.data || [];
            setSolist(data);
        } catch (error) {
            console.log('error', error);
        }
    };

    const fetchClothDataSOno = async (id) => {
        try {
            const res = await axios.get(`${baseUrl}?apicall=getClothDataPOclothusingSOID&soId=${id}`);
            const data = res.data?.data;
            return data;
        } catch (error) {
            console.log('error', error);
        }
    };

    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement

    const handleDropdownChange = async (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
        if (dropdownType === 'cloth' && value) {
            const selCloth = clothList?.data?.length > 0 ? clothList?.data?.find((item) => item.ID === value) : [];

            if (selCloth) {
                const { ID, clothNm, uom, hsn, color, model, panna_size, shadeNo } = selCloth;
                handleAddRow(clothNm, uom, hsn, ID, color, model, panna_size, shadeNo);
            }
            setTimeout(() => {
                setFormData({
                    ...formData,
                    cloth: ''
                });
            }, 1000);

        }
        if (dropdownType === 'soId' && value) {

            const data = await fetchClothDataSOno(value);

            if (data) {

                // setFormData(prev => ({
                //     ...prev,
                //     firm: data.firmId,
                //     vender: data.partyId,
                //     firmNm: data.firmNm,
                //     partyNm: data.partyNm
                // }));

                const clothKeys = ['mcloth', 'm1Id', 'm2Id', 'm3Id'];

                clothKeys.forEach((key) => {

                    const clothId = data[key];

                    // ✅ Skip if clothId is 0, null, undefined, empty
                    if (clothId && Number(clothId) !== 0) {

                        const mcloth = clothList?.data?.find(
                            item => Number(item.ID) === Number(clothId)
                        );


                        if (mcloth) {
                            const soId = data?.ID;
                            const sono = data?.sono;
                            const {
                                ID,
                                clothNm,
                                uom,
                                hsn,
                                color,
                                model,
                                panna_size,
                                shadeNo

                            } = mcloth;

                            handleAddRow(
                                clothNm,
                                uom,
                                hsn,
                                ID,
                                color,
                                model,
                                panna_size,
                                shadeNo,
                                soId,
                                sono,
                            );

                        }

                    }

                });

            }

        }
    };
    const handleDateChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };

    const handleRowInputChange = (index, e) => {
        const { name, value } = e.target;
        const newRows = [...tableRows];
        newRows[index][name] = value;
        if (name === 'amount' || name === 'IGST' ||
            name === 'IGSTAmt' || name === 'CGST' || name === 'CGSTAmt' || name === 'SGST' ||
            name === 'SGSTAmt') {
            if (!/^\d*$/.test(value)) {
                return;
            }
        }
        // Calculate amount if 'rate' or 'meter' changes


        // Calculate IGSTAmt based on state_type and IGST percentage

        // state type =
        //  inside - 0
        // outside - 1
        if (formData.vender !== '') {
            if (name === 'rate' || name === 'meter') {
                const rate = parseFloat(newRows[index]['rate']) || 0;
                const meter = parseFloat(newRows[index]['meter']) || 0;
                newRows[index]['amount'] = (rate * meter).toFixed(2);

                // Calculate CGST and SGST amounts based on amount
                const amount = parseFloat(newRows[index]['amount']) || 0;
                const CGSTPercent = parseFloat(newRows[index]['CGST']) || 0;
                const SGSTPercent = parseFloat(newRows[index]['SGST']) || 0;
                newRows[index]['CGSTAmt'] = ((amount * CGSTPercent) / 100).toFixed(2);
                newRows[index]['SGSTAmt'] = ((amount * SGSTPercent) / 100).toFixed(2);
            }
            const stateType = partyList.data.length > 0 ? partyList.data.find((item) => item.ID === formData.vender) : '';

            if (stateType.state_type === '1' || name === 'IGST' || name === 'amount') {
                const amount = parseFloat(newRows[index]['amount']) || 0;
                const IGSTPercent = parseFloat(newRows[index]['IGST']) || 0;
                newRows[index]['IGSTAmt'] = ((amount * IGSTPercent) / 100).toFixed(2);
                newRows[index]['CGSTAmt'] = '0';
                newRows[index]['SGSTAmt'] = '0';

                var totalTaxAmt = newRows.reduce((total, row) => total + parseFloat(row.IGSTAmt || 0), 0);
            }

            if (stateType.state_type === '0' || name === 'amount' || name === 'CGST' || name === 'SGST') {
                const amount = parseFloat(newRows[index]['amount']) || 0;
                const CGSTPercent = parseFloat(newRows[index]['CGST']) || 0;
                const SGSTPercent = parseFloat(newRows[index]['SGST']) || 0;

                newRows[index]['CGSTAmt'] = ((amount * CGSTPercent) / 100).toFixed(2);
                newRows[index]['SGSTAmt'] = ((amount * SGSTPercent) / 100).toFixed(2);
                newRows[index]['IGSTAmt'] = '0';

                var cgst1 = newRows.reduce((total, row) => total + parseFloat(row.CGSTAmt || 0), 0);
                var sgst1 = newRows.reduce((total, row) => total + parseFloat(row.SGSTAmt || 0), 0);
                var totalTaxAmt = cgst1 + sgst1;
            }
            if (name === 'amount' || name === 'CGST' || name === 'SGST') {
                const amount = parseFloat(newRows[index]['amount']) || 0;
                const CGSTPercent = parseFloat(newRows[index]['CGST']) || 0;
                const SGSTPercent = parseFloat(newRows[index]['SGST']) || 0;

                newRows[index]['CGSTAmt'] = ((amount * CGSTPercent) / 100).toFixed(2);
                newRows[index]['SGSTAmt'] = ((amount * SGSTPercent) / 100).toFixed(2);
                newRows[index]['IGSTAmt'] = '0';

                var cgst = newRows.reduce((total, row) => total + parseFloat(row.CGSTAmt || 0), 0);
                var sgst = newRows.reduce((total, row) => total + parseFloat(row.SGSTAmt || 0), 0);
                var totalTaxAmt = cgst + sgst;
            }

            if (name === 'IGST') {
                // console.log(value);
                const amount = parseFloat(newRows[index]['amount']) || 0;
                const percentage = parseFloat(value);
                newRows[index]['IGST'] = percentage;

                if (stateType.state_type === '0') {
                    const halfPer = percentage / 2;
                    newRows[index]['CGST'] = halfPer;
                    newRows[index]['SGST'] = halfPer;

                    newRows[index]['CGSTAmt'] = ((amount * halfPer) / 100).toFixed(2);
                    newRows[index]['SGSTAmt'] = ((amount * halfPer) / 100).toFixed(2);
                    newRows[index]['IGSTAmt'] = '0';

                    var cgst = newRows.reduce((total, row) => total + parseFloat(row.CGSTAmt || 0), 0);
                    var sgst = newRows.reduce((total, row) => total + parseFloat(row.SGSTAmt || 0), 0);
                    var totalTaxAmt = Math.round(cgst + sgst);
                } else {
                    newRows[index]['IGSTAmt'] = ((amount * percentage) / 100).toFixed(2);
                    newRows[index]['CGSTAmt'] = '0';
                    newRows[index]['SGSTAmt'] = '0';

                    var totalTaxAmt = Math.round(newRows.reduce((total, row) => total + parseFloat(row.IGSTAmt || 0), 0));
                }
            }

            const totalMeter = newRows.reduce((total, row) => total + parseFloat(row.meter || 0), 0)
            const totalAmount = Math.round(newRows.reduce((total, row) => total + parseFloat(row.amount || 0), 0));
            const finalAmt = Math.round(totalTaxAmt + totalAmount);

            const updatedFormData = {
                ...formData,
                amt: totalAmount,
                tQtyM: totalMeter.toFixed(2),
                taxAmt: totalTaxAmt,
                fAmt: finalAmt
            };

            // Update tableRows state
            setTableRows(newRows);
            // Update formData state
            setFormData(updatedFormData);
        }
    };


    const debouncedHandleChange = (index, e) => {
        const { name, value } = e.target;
        handleRowInputChange(index, name, value);
    };

    const handleAddRow = (clothNm, uom, hsn, value, color, model, panna_size, shadeNo, soId, sono) => {
        // const exists = tableRows.some(
        //     row => row.clothId === value && row.soId === soId
        // );

        // if (exists) {
        //     alert("This Cloth with the same SO already exists.");
        //     return;
        // }
        // const newRow = {
        //     clothId: value,
        //     cloth: `${clothNm} ${model} ${color} ${shadeNo} ${panna_size}`,
        //     hsn: hsn,
        //     unit: uom,
        //     deliveryDate: '',
        //     rate: '0',
        //     meter: '0',
        //     amount: '0',
        //     IGST: '5',
        //     IGSTAmt: '0',
        //     CGST: '2.5',
        //     CGSTAmt: '0',
        //     SGST: '2.5',
        //     SGSTAmt: '0',
        //     soId: soId,
        //     sono: sono
        // };
        // setTableRows([...tableRows, newRow]);

        setTableRows(prevRows => {
            const exists = prevRows.some(row => {
                if (soId) {
                    // when soId exists check clothId + soId
                    return (
                        String(row.clothId) === String(value) &&
                        String(row.soId) === String(soId)
                    );
                } else {
                    // when soId is empty check only clothId
                    return String(row.clothId) === String(value);
                }
            });

            if (exists) {
                alert("This Cloth already exists.");
                return prevRows;
            }

            return [
                ...prevRows,
                {
                    clothId: String(value),
                    cloth: `${clothNm} ${model} ${color} ${shadeNo} ${panna_size}`,
                    hsn,
                    unit: uom,
                    deliveryDate: '',
                    rate: 0,
                    meter: '0',
                    amount: '0',
                    IGST: '5',
                    IGSTAmt: '0',
                    CGST: '2.5',
                    CGSTAmt: '0',
                    SGST: '2.5',
                    SGSTAmt: '0',
                    soId: soId ? String(soId) : '0',
                    sono
                }
            ];
        });
        setFormData(prev => ({
            ...prev,
            soId: ''
        }));
    };

    function convertIntoOneObject(array, formData) {
        // const tableData = {
        //     clothId: [...array.map((item) => item.clothId)],
        //     deldt: [...array.map((item) => item.deliveryDate)],
        //     rate: [...array.map((item) => item.rate)],
        //     meter: [...array.map((item) => item.meter)],
        //     amount: [...array.map((item) => item.amount)],
        //     IGST: [...array.map((item) => item.IGST)],
        //     IGSTAmt: [...array.map((item) => item.IGSTAmt)],
        //     CGST: [...array.map((item) => item.CGST)],
        //     CGSTAmt: [...array.map((item) => item.CGSTAmt)],
        //     SGST: [...array.map((item) => item.SGST)],
        //     SGSTAmt: [...array.map((item) => item.SGSTAmt)],
        //     // Include formData fields

        //     vender: formData.vender,
        //     PoNo: formData.PoNo,
        //     ordt: formData.ordt,
        //     firm: formData.firm,
        //     tQtyM: formData.tQtyM,
        //     amt: formData.amt,
        //     taxAmt: formData.taxAmt,
        //     fAmt: formData.fAmt,
        //     shftTo: formData.shftTo,
        //     ref: formData.ref,
        //     userId: formData.userId
        // };
        for (let i = 0; i < array.length; i++) {

            if (!array[i].clothId || array[i].clothId === '') {
                alert("Please select Cloth in row " + (i + 1));
                return false;
            }

            if (!array[i].deliveryDate || array[i].deliveryDate === '') {
                alert("Please select Delivery Date in row " + (i + 1));
                return false;
            }
        }
        const data = {
            tableData: array,
            vender: formData.vender,
            PoNo: formData.PoNo,
            ordt: formData.ordt,
            firm: formData.firm,
            tQtyM: formData.tQtyM,
            amt: formData.amt,
            taxAmt: formData.taxAmt,
            fAmt: formData.fAmt,
            shftTo: formData.shftTo,
            ref: formData.ref,
            ordtype: formData.ordtype,
            userId: formData.userId
        }
        return data;
    };

    const handleCheckboxChange = (index) => {
        setSelectedRows((prevSelectedRows) => {
            if (prevSelectedRows.includes(index)) {
                return prevSelectedRows.filter((rowIndex) => rowIndex !== index);
            } else {
                return [...prevSelectedRows, index];
            }
        });
    };

    const handleDeleteRows = () => {
        setTableRows((prevRows) => prevRows.filter((_, index) => !selectedRows.includes(index)));
        setSelectedRows([]);
    };

    const handleDropdownOpen = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: true }));
    };

    const handleDropdownClose = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: false }));
    };

    const handleNavigateCloth = () => {
        window.open(`/NewClothEntry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    const handleNavigateParty = () => {
        window.open(`/NewPartyEntry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    const orderOptions = [
        { label: 'Manual', value: 'Manual' },
        { label: 'Sale Order', value: 'Sale Order' }
    ];


    const dropdownlistfirst = [
        {
            label: 'Cloth',
            id: 'cloth',
            options: clothList?.data || [],
            value: formData.cloth,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'cloth', value: newValue ? newValue.ID : '' } }, 'cloth'),
            getOptionLabel: (option) => `${option.clothNm} ${option.model} ${option.color} ${option.shadeNo} ${option.panna_size}` || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleNavigateCloth(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('cloth'),
            handleDropdownClose: () => handleDropdownClose('cloth'),
        }
    ];

    const dropdownparty = [

        {
            label: 'Purchase Party',
            id: 'vender',
            options: partyList?.data || [],
            value: formData.vender,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'vender', value: newValue ? newValue.ID : '' } }, 'vender'),
            getOptionLabel: (option) => option.partyNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleNavigateParty(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('vender'),
            handleDropdownClose: () => handleDropdownClose('vender'),
        }
    ];

    const handleRadioChange = (e) => {

        const { name, value } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: value,
            fAmt: '0',
            firm: '',
            taxAmt: '0',
            tQtyM: '0',
            amt: '0',
            vender: '',
            shftTo: '',
            ref: ''
        }));
        setTableRows([]);
    };

    const dropdownlistsecond = [
        {
            label: 'Firm',
            id: 'firm',
            options: firmList?.data,
            value: formData.firm,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'firm', value: newValue ? newValue.ID : '' } }, 'firm'),
            getOptionLabel: (option) => option.firmNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        }
    ];

    const dropdownsolist = [
        {
            label: 'Sale Order',
            id: 'soId',
            options: solist || [],
            value: formData.soId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'soId', value: newValue ? newValue.ID : '' } }, 'soId'),
            getOptionLabel: (option) => option.itemNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        }
    ];
    // console.log(clothList)

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const finalObject = convertIntoOneObject(tableRows, formData);
            // console.log(finalObject);

            const result = await axios.post(`${baseUrl}?apicall=insertPurchaseOrderClothEntry`, finalObject);
            const data = result?.data;
            if (data.status === "success") {
                alert(data.msg);
                window.location.reload();
            } else {
                const msg = Array.isArray(data.msg) ? data.msg.join("\n") : data.msg;
                alert(msg);
            }

            // const result = await dispatch(createPOEntry(finalObject)).unwrap();
            // console.log('POST request successful!', result);
            // // toast.success("Purchase Order Added");
            // alert("Purchase Order Added");
            // window.location.reload();
        } catch (error) {
            console.error('Error while making POST request:', error);
        } finally {
            setLoading(false);
        }


    };

    return (
        <>
            <Titlebar data={PurchaseOrdMaster} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Purchase Order Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>

                                <RadioComponent
                                    label='Order Type'
                                    name='ordtype'
                                    value={formData.ordtype}
                                    options={orderOptions}
                                    isDesktop={isDesktop}
                                    onChange={handleRadioChange}
                                />

                                {[
                                    { label: 'PO No', name: 'PoNo' },
                                    { label: 'Date', name: 'ordt', type: 'date' }

                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.inputDate }}
                                                            sx={inputStyles}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.name == 'PoNo' }}
                                                            sx={inputStyles}
                                                        />
                                                    )}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}



                                {
                                    formData.ordtype === "Sale Order" && dropdownsolist && dropdownsolist.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    ))
                                }

                                {
                                    dropdownlistsecond && dropdownlistsecond.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    ))
                                }

                                {
                                    dropdownparty && dropdownparty.map((drop) => (
                                        <DropdownWithBtn
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                            handleAddNew={drop.handleAddNew}
                                            btnlabel={drop.btnlabel}
                                            handleDropdownOpen={drop.handleDropdownOpen}
                                            handleDropdownClose={drop.handleDropdownClose}
                                        />
                                    ))
                                }






                                {/* {formData.ordtype === "Sale Order" &&
                                    [
                                        { label: 'Firm', name: 'firmNm', type: 'readOnly' },
                                        { label: 'Party', name: 'partyNm', type: 'readOnly' }
                                    ].map((field, index) => (
                                        <Grid item xs={12} md={6} key={index}>
                                            <Grid container alignItems="center" spacing={1}>
                                                <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                    <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                                </Grid>
                                                <Grid item xs>
                                                    <FormControl fullWidth>
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name] || ''}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.type === 'readOnly' }}
                                                            sx={inputStyles}
                                                        />
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    ))} */}


                                {[
                                    { label: 'Total Mtr/KG', name: 'tQtyM', type: 'readOnly' },
                                    { label: 'Amount', name: 'amt', type: 'readOnly' },
                                    { label: 'Tax Amount', name: 'taxAmt', type: 'readOnly' },
                                    { label: 'Taxable Amount', name: 'fAmt', type: 'readOnly' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name] || ''}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input, readOnly: field.type === 'readOnly' }}
                                                        sx={inputStyles}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}



                                {[
                                    { label: 'Shift to', name: 'shftTo' },
                                    { label: 'Reference', name: 'ref' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextareaAutosize
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name]}
                                                        onChange={handleInputChange}
                                                        style={{ width: '80%', height: '100px', padding: '5px', borderRadius: '4px', border: '1px solid #000', ...styled.input }}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                <Grid item xs={6}>

                                </Grid>

                                {
                                    formData.ordtype === "Manual" && dropdownlistfirst && dropdownlistfirst.map((drop) => (
                                        <DropdownWithBtn
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                            handleAddNew={drop.handleAddNew}
                                            btnlabel={drop.btnlabel}
                                            handleDropdownOpen={drop.handleDropdownOpen}
                                            handleDropdownClose={drop.handleDropdownClose}
                                        />
                                    ))
                                }



                                <Grid item xs={12}>
                                    <Button variant="contained" color="secondary" onClick={handleDeleteRows} disabled={selectedRows.length === 0}>Delete</Button>
                                </Grid>
                                <Grid item xs={12}>
                                    <div>
                                        <TableContainer width={400}>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Select</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Sr.No.</TableCell>
                                                        {formData.ordtype === "Sale Order" &&
                                                            <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>SO No.</TableCell>}
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Cloth</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>HSN</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Unit</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Delivery Date</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Rate</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Meter/KG</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Amount</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>IGST(%)</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>IGSTAmt</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>CGST(%)</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>CGSTAmt</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>SGST(%)</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>SGSTAmt</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {tableRows?.map((row, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                <Checkbox
                                                                    checked={selectedRows.includes(index)}
                                                                    onChange={() => handleCheckboxChange(index)}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                {index + 1}
                                                            </TableCell>
                                                            {formData.ordtype === "Sale Order" &&
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                    {row.sono}
                                                                </TableCell>
                                                            }
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                {row.cloth}
                                                            </TableCell>
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                {row.hsn}
                                                            </TableCell>
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                {row.unit}
                                                            </TableCell>
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    type="date"
                                                                    name="deliveryDate"
                                                                    value={row.deliveryDate}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    inputProps={{ style: styled.inputTables }}
                                                                /> */}
                                                                <input
                                                                    type="date"
                                                                    name="deliveryDate"
                                                                    value={row.deliveryDate}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    style={{ width: '100px', padding: '1px' }}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    name="rate"
                                                                    value={row.rate}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    inputProps={{ style: styled.inputTables }}
                                                                /> */}
                                                                <input
                                                                    type='number'
                                                                    name="rate"
                                                                    value={row.rate}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    style={{ width: '80px', padding: '1px' }}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    name="meter"
                                                                    value={row.meter}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    inputProps={{ style: styled.inputTables }}
                                                                /> */}
                                                                <input
                                                                    type='number'
                                                                    name="meter"
                                                                    value={row.meter}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    style={{ width: '80px', padding: '1px' }}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    name="amount"
                                                                    value={row.amount}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    inputProps={{ style: styled.inputTables }}
                                                                /> */}
                                                                <input
                                                                    type='text'
                                                                    name="amount"
                                                                    value={row.amount}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    style={{ width: '50px', padding: '1px' }}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>

                                                                {/* <input
                                                                    type='text'
                                                                    name="IGST"
                                                                    value={row.IGST}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    style={{ width: '50px', padding: '1px' }}
                                                                /> */}
                                                                <select name="IGST" value={row.IGST} onChange={(e) => handleRowInputChange(index, e)}>
                                                                    <option value="5">5</option>
                                                                    <option value="12">12</option>
                                                                    <option value="18">18</option>
                                                                </select>
                                                            </TableCell>
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>

                                                                {/* <input
                                                                    type='text'
                                                                    name="IGSTAmt"
                                                                    value={row.IGSTAmt}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    style={{ width: '50px', padding: '1px' }}
                                                                /> */}

                                                                {row.IGSTAmt}
                                                            </TableCell>
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>

                                                                {/* <input
                                                                    type='text'
                                                                    name="CGST"
                                                                    value={row.CGST}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    style={{ width: '50px', padding: '1px' }}
                                                                /> */}

                                                                {row.CGST}
                                                            </TableCell>
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>

                                                                {/* <input
                                                                    type='text'
                                                                    name="CGSTAmt"
                                                                    value={row.CGSTAmt}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    style={{ width: '50px', padding: '1px' }}
                                                                /> */}
                                                                {row.CGSTAmt}
                                                            </TableCell>
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>

                                                                {/* <input
                                                                    type='text'
                                                                    name="SGST"
                                                                    value={row.SGST}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    style={{ width: '50px', padding: '1px' }}
                                                                /> */}
                                                                {row.SGST}
                                                            </TableCell>
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>

                                                                {/* <input
                                                                    type='text'
                                                                    name="SGSTAmt"
                                                                    value={row.SGSTAmt}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    style={{ width: '50px', padding: '1px' }}
                                                                /> */}
                                                                {row.SGSTAmt}
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                </Grid>

                                {tableRows?.length > 0 &&
                                    (<Grid item xs={12} textAlign="center">
                                        <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading === true}>
                                            {
                                                loading === true ?
                                                    <><CircularProgress size="20px" /> wait...</> :
                                                    "Submit"
                                            }
                                        </Button>
                                    </Grid>)}

                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default PurchaseOrderEntry;
